import PaginaTexto from '@/components/feature/PaginaTexto';
import { privacidade } from '@/conteudo/privacidade';

export default function PrivacidadePage() {
  return <PaginaTexto documento={privacidade} />;
}